"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AcCloseIconButton_1 = require("../button/AcCloseIconButton");
exports.AcSlimCard = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement(react_bootstrap_1.Card, { className: "rounded-0 border-0 bg-transparent" },
        react_1.default.createElement(react_bootstrap_1.Card.Header, { className: "p-0 bg-transparent border-0 d-flex justify-content-end" },
            react_1.default.createElement(AcCloseIconButton_1.AcCloseIconButton, null)),
        react_1.default.createElement(react_bootstrap_1.Card.Body, { className: "p-0" }, children)));
};
//# sourceMappingURL=AcSlimCard.js.map